import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import Select from 'react-select';

import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import { customStyle } from 'helper';
import useDebounce from 'modules/common/components/UseDebounce';
import GenericListPair from 'modules/common/components/GenericListPair';

import * as actions from '../action';
import * as c from '../constant';
import MunicipalityContent from './MunicipalityContent';

const form = {
  keyword: '',
};

function MuncipalityContainer({
  match,
  isLoading,
  history,
  getMunicipalityList,
  municipalityList,
  municipalityListPager,
  getRegionsList,
  getProvinceList,
  regionsList,
  provinceList,
}) {
  const [formData, setFormData] = useState(form);
  const [region, setRegion] = useState({
    label: '',
    value: 0,
  });
  const [province, setProvince] = useState({
    label: '',
    value: 0,
  });

  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeSelect = (e) => {
    setRegion(e);
    getProvinceList({ region_code: e.value });
    setProvince('');
  };

  const handleProvinceSelect = (e) => {
    setProvince(e);
    getMunicipalityList({ province_code: e.value });
    // getProvinceList({ region_code: e.value });
  };

  useEffect(() => {
    getMunicipalityList({ region_code: region.value, isPaginate: 1 });
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const createDropdown = (list) => {
    const newList = [];
    list.map((data) => {
      return newList.push({
        label: data.attributes.name,
        value: data.attributes.code,
      });
    });
    return newList;
  };

  useEffect(() => {
    getRegionsList();

    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    name: formData.keyword,
    sort_by: 'asc',
    region_code: region.value
  };

  useEffect(() => {
    if (debouncedSearchTerm) {
      getMunicipalityList({ region_code: region.value, name: formData.keyword, isPaginate: 1 });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <Route
      path={`${match.path}/:municipalityId?`}
      render={({ match: { params } }) => (
        <div>
          <div className="card p-0 mb-3 mt-3">
            <div className="container-fluid d-flex px-0">
              <div className="d-inline w-auto d-flex justify-content-start m-3">
                <label className="label-transaction-card mb-0 d-flex align-items-center mr-3">
                  Select Region:
                </label>
                <div style={{ width: 250 }}>
                  <Select
                    styles={customStyle}
                    placeholder="Select Region"
                    value={region}
                    options={createDropdown(regionsList)}
                    onChange={(e) => {
                      handleChangeSelect(e);
                    }}
                  />
                </div>
              </div>
              <div className="d-inline w-auto d-flex justify-content-start m-3">
                <label className="label-transaction-card mb-0 d-flex align-items-center mr-3">
                  Select Province:
                </label>
                <div style={{ width: 250 }}>
                  <Select
                    styles={customStyle}
                    placeholder="Select Province"
                    value={province}
                    options={createDropdown(provinceList)}
                    onChange={handleProvinceSelect}
                  />
                </div>
              </div>
            </div>
          </div>
          <GenericListPair
            moduleName="Municipality List"
            getData={getMunicipalityList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search Municipality..."
            pathName={`${match.path}/:municipalityId?`}
            listName="Municipality"
            label="Municipality"
            renderItem={(item) => (
              <div className="p-3">
                <div className="transaction-list-company">
                  {_.get(item, 'attributes.name')}
                </div>
              </div>
            )}
            isLoading={isLoading}
            selected={params.municipalityId}
            data={municipalityList}
            dataPager={municipalityListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:municipalityId?`}
                    render={() => (
                      <MunicipalityContent />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:municipalityId?`}
                  render={() =>
                    !params.municipalityId && municipalityList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(municipalityList, '0.id')}`}
                      />
                    ) : (
                      <Redirect
                        to={`${match.url}/${_.get(municipalityList, '0.id')}`}
                      />
                    )
                  }
                />
              </React.Fragment>
            )}
          />
        </div>
      )}
    />
  );
}

MuncipalityContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getMunicipalityList: PropTypes.instanceOf(Function).isRequired,
  getRegionsList: PropTypes.instanceOf(Function).isRequired,
  getProvinceList: PropTypes.instanceOf(Function).isRequired,
  municipalityList: PropTypes.instanceOf(Array).isRequired,
  regionsList: PropTypes.instanceOf(Array).isRequired,
  provinceList: PropTypes.instanceOf(Array).isRequired,
  municipalityListPager: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  isLoading: api.loading.indexOf(c.GET_MUNICIPALITY_LIST) > -1,
  municipalityList: _.get(api, `${c.GET_MUNICIPALITY_LIST}.list`) || [],
  regionsList: _.get(api, `${c.GET_REGION}.list`) || [],
  provinceList: _.get(api, `${c.GET_PROVINCE}.list`) || [],
  municipalityListPager: _.get(api, `${c.GET_MUNICIPALITY_LIST}.pager`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(MuncipalityContainer);
